import { connect } from 'react-redux';
import decorate from '../../../utils/decorate';
import { List } from 'immutable';

import { request as getLastLegs } from '../../../modules/liabilities/actions/last-legs-rum';

import LastLetRum from './LastLetRum.jsx';

function mapStateToProps(state) {
    return {
        selections: state.liabilities.getIn([ 'rumlegs', 'items' ]) || List(),
        status: state.liabilities.getIn([ 'rumlegs', 'status' ], 'FINISHED' )
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getLastLegs() {
            dispatch(getLastLegs());
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    LastLetRum
);
